module.exports = __webpack_public_path__ + "img/lc.763541c7.svg";